import FootballPlay from "../../football/play/football-play";
import FlagFootballPlayState from "../state/flag-football-play-state";
import FlagFootballGameContext from "../context/flag-football-game-context";
import SportCodes from "../../common/sport-codes";

export default class FlagFootballPlay extends FootballPlay {
    constructor() {
        super(
            new FlagFootballPlayState(),
            new FlagFootballGameContext().generateSnapshot()
        );
    }

    getSportCode() {
        return SportCodes.FlagFootball;
    }
}
